import React, { useEffect } from 'react';
import { Button } from 'antd';
import rpp from './RequestsProductionsPage.module.scss';
import WithMainContainer from '@/components/layout';
import g from '@/general.module.scss';
import logo from '/public/static/images/image_logo_full.svg';
import Head from 'next/head';
import { useStores } from '@/utils/hooks/useStores';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';
import HeadService from '@/utils/services/HeadService';

function RequestsProductionsPage() {
    const {
        systemStore: { setBreadcrumbs },
        modalsStore: { openRegisterForm },
    } = useStores();
    const LOCALIZATION = useLocalization();
    useEffect(() => {
        setBreadcrumbs([
            {
                key: '/',
                title: LOCALIZATION.routes.home,
            },
            {
                key: '/requests',
                title: LOCALIZATION.routes.requests,
            },
            {
                key: `/requests/production`,
                title: LOCALIZATION.routes.production,
            },
        ]);
    }, [LOCALIZATION]);

    return (
        <>
            {process.env.NEXT_PUBLIC_INCLUDE_SEO_TAGS === 'true' &&
                HeadService.simpleBuild(
                    'Запросы на изготовление в TKMP.Istok',
                    '/requests/production',
                )}
            <div className={g.mainContainer}>
                <div className={rpp.itemChildTab}>
                    <span className="text-24-500">
                        {LOCALIZATION.pages.production_request.production_request_title}
                    </span>
                    <span className="text-16-400">
                        {LOCALIZATION.pages.production_request.production_request_text1}
                    </span>
                    <span className="text-16-400">
                        {LOCALIZATION.pages.production_request.production_request_text2}
                    </span>
                    <Button
                        className={rpp.btnTabs}
                        onClick={openRegisterForm}
                    >
                        {LOCALIZATION.pages.production_request.production_request_become_member}
                    </Button>
                </div>
            </div>
        </>
    );
}

export default WithMainContainer(RequestsProductionsPage);
